module.exports = __webpack_public_path__ + "img/special6.11890df5.png";